import React from 'react';
import 'components/Auth/Login.scss';
import TextField from '@material-ui/core/TextField';
import DialogContent from '@material-ui/core/DialogContent';
import Button from '@material-ui/core/Button';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import FormHelperText from '@material-ui/core/FormHelperText';
import axios from 'axios';
import Qs from 'qs';
import Conf from 'utils/Conf';
import Pager from 'components/Pager';
import {withTranslation} from 'react-i18next';

class LoginPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      password: '',
      submitted: false,
      error: '',
      loggingIn: false,
      idx: 0,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleSubmitForgottenPassword = this.handleSubmitForgottenPassword.bind(this);
    this.go = this.go.bind(this);
    this.handleRegisterButton = this.handleRegisterButton.bind(this);
  }
  go(idx) {
    this.setState({idx: idx});
  }
  handleChange(e) {
    const {name, value} = e.target;
    this.setState({[name]: value});
  }
  handleSubmit(e) {
    e.preventDefault();
    this.setState({submitted: true});
    const {email, password} = this.state;
    if (email && password) {
      this.props.methods.login(email, password, data => {
        if (data.status === 'success') {
          this.props.methods.getProfile(() => {
            this.props.onLogin && this.props.onLogin();
            this.setState({loggingIn: false}, this.props.onClose);
            return;
          });
        } else this.setState({error: data.error, loggingIn: false});
        return;
      });
    }
  }
  handleSubmitForgottenPassword(e) {
    e.preventDefault();
    const {email} = this.state;
    if (email) {
      axios
        .post(Conf.apiBaseUriLegacy + '/user/forgotten_password', Qs.stringify({email: email}), {withCredentials: true})
        .then(res => {
          if (res.data.status === 'success') {
            this.go(2);
          } else {
            this.setState({passwordError: res.data.error});
          }
        });
    }
  }
  handleRegisterButton(e) {
    this.props.onSwitchToRegister();
  }
  render() {
    const {email, password, submitted, error, idx, passwordError} = this.state;
    const {t, noRegisterBtn, onClose} = this.props;
    return (
      <Pager
        idx={idx}
        pages={[
          <form name="form" onSubmit={this.handleSubmit}>
            <DialogTitle>{t('connexion')}</DialogTitle>
            <DialogContent>
              <TextField
                fullWidth
                error={submitted && !email}
                variant="filled"
                margin="dense"
                label={t('e-mail')}
                name="email"
                value={email}
                onChange={this.handleChange}
                helperText={submitted && !email && t('e-mail-obligatoire')}
              />
              <TextField
                fullWidth
                error={submitted && !password}
                margin="dense"
                variant="filled"
                type="password"
                label={t('mot-de-passe')}
                className="form-control"
                name="password"
                value={password}
                onChange={this.handleChange}
                helperText={submitted && !password && t('mot-de-passe-obligatoire')}
              />
              {error && (
                <FormHelperText error>
                  {t(error)}
                  <br />
                  {t('si-vous-avez-deja-un-ticket-creez-un-compte')}
                </FormHelperText>
              )}
              <div className="spacer"></div>
              <div className="forgotten-password-btn" onClick={() => this.go(1)}>
                {t('mot-de-passe-oublie')}
              </div>
            </DialogContent>
            <DialogActions>
              {!noRegisterBtn && (
                <Button onClick={this.handleRegisterButton} color="primary" variant="outlined">
                  {t('creer-un-compte')}
                </Button>
              )}
              <Button color="primary" type="submit" variant="contained">
                {t('se-connecter')}
              </Button>
            </DialogActions>
          </form>,
          <form name="form" onSubmit={this.handleSubmitForgottenPassword}>
            <DialogTitle>{t('mot-de-passe-oublie')}</DialogTitle>
            <DialogContent>
              <TextField
                fullWidth
                error={submitted && !email}
                variant="filled"
                margin="dense"
                label={t('e-mail')}
                name="email"
                value={email}
                onChange={this.handleChange}
                helperText={submitted && !email && t('e-mail-obligatoire')}
              />
              {passwordError && <FormHelperText error>{passwordError}</FormHelperText>}
              <div className="spacer"></div>
            </DialogContent>
            <DialogActions>
              <Button color="primary" type="submit" variant="contained" disabled={this.email === ''}>
                {t('envoyer')}
              </Button>
            </DialogActions>
          </form>,
          <React.Fragment>
            <DialogContent>
              <p>{t('un-email-vous-a-ete-envoye-avec-un-lien-pour-choisir-votre-nouveau-mot-de-passe')}</p>
            </DialogContent>
            <DialogActions>
              <Button color="primary" variant="contained" onClick={onClose}>
                {t('fermer')}
              </Button>
            </DialogActions>
          </React.Fragment>,
        ]}
      />
    );
  }
}
export default withTranslation()(LoginPage);
